import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=40c84eea&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40c84eea')) {
      api.createRecord('40c84eea', component.options)
    } else {
      api.reload('40c84eea', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=40c84eea&", function () {
      api.rerender('40c84eea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2JdO0dcqRaHBS/JS/pricehelp.vue"
export default component.exports